var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"menu-item py-0",attrs:{"dense":""}},_vm._l((_vm.menuItems),function(item,index){return _c('MenuItem',{key:index,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }